import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useNavigate } from "react-router-dom";
import { viewlist } from "../../../api/BatchService";
import {
  StudentList,
  StudentListProfile,
  StudentListProfilePost,
} from "../../../api/StudentServices";
import { fectchIdCardV2, staffIdCard } from "../../../api/IdCard";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./id.css";
import "./profile-update.css";
import { imgBaseUrl } from "../../../api/api";
import { getSessions } from "../../../api/SessionsService";
import { ToastMain, SweetAlertShow, LoadingDiv } from "../../master/Master";
import IdCardLayout from "../../idCards/IdCardLayout";

export default function ProfileUpdate() {
  const [idType, setIdType] = useState("student");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectAllStudents, setSelectAllStudents] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const [Data, setData] = useState({});
  const [batch, setBatch] = useState();
  const [renderedCards, setRenderedCards] = useState([]);
  const [idCardMeta, setIdCardMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [idCard, setIdCard] = useState("");
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  const [tab, setTab] = useState("pending");
  const [selectedFiles, setSelectedFiles] = useState({}); // store captured photos
  const [page, setPage] = useState(1);

  const handleCapture = async (e, studentId) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const compressedFile = await compressImage(file, 0.9 * 1024 * 1024); // ~0.9MB
      const reader = new FileReader();
      // reader.onloadend = () => setPreview(reader.result); // if you have a preview component
      reader.readAsDataURL(compressedFile);
      setSelectedFiles((prev) => ({ ...prev, [studentId]: compressedFile }));

      console.log(
        `Compressed file for student ${studentId}:`,
        (compressedFile.size / 1024 / 1024).toFixed(2),
        "MB",
      );
    } catch (err) {
      console.error("Image compression failed:", err);
      ToastMain.fire({
        icon: "error",
        title: "Image compression failed. Please try again.",
      });
    }
  };

  const compressImage = (file, targetSize = 0.9 * 1024 * 1024) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;
          const scaleFactor = Math.sqrt(targetSize / file.size);

          canvas.width = width * scaleFactor;
          canvas.height = height * scaleFactor;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              const fileName = file.name
                ? file.name.replace(/\.[^/.]+$/, "")
                : "compressed_image";
              const finalFileName = `${fileName}.jpeg`;

              const compressedFile = new File([blob], finalFileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });

              resolve(compressedFile);
            },
            "image/jpeg",
            1,
          );
        };
      };
    });
  };

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();

      if (response?.data?.status) {
        const sessionList = response.data.data || [];
        setSessions(sessionList);

        const activeSession = sessionList.find(
          (session) => session.status === "1",
        );

        if (activeSession) {
          setSelectedSessions(String(activeSession.id));
        }
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getSession();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [tab, selectedBatch]);

  useEffect(() => {
    if (selectedSession) {
      setSelectedBatch("");
      setBatch([]);
      setData({});
      fetchBatches();
    }
  }, [selectedSession]);

  useEffect(() => {
    if (selectedBatch) {
      fetchStudents();
    }
  }, [selectedBatch, page, selectedSession, tab]);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);

    try {
      const response = await viewlist(addUrl);

      if (response?.data?.status) {
        setBatch(response.data.data || []);
      } else {
        setBatch([]);
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      console.error(err);
      setBatch([]);
      Swal.fire("Error", "Error fetching batches", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async () => {
    if (!selectedBatch) return;

    let addUrl = `&batch_id=${selectedBatch}&page=${page}`;

    if (tab === "pending") {
      addUrl += "&status=0";
    } else if (tab === "uploaded") {
      addUrl += "&status=1";
    }

    setLoading(true);

    try {
      const res = await StudentListProfile(addUrl);

      if (res?.data?.status) {
        setData(res.data.data || {});
      } else {
        setData({});
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (err) {
      setData({});
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (studentId) => {
    if (!selectedBatch) {
      SweetAlertShow("warning", "Warning", "Please select a batch first.");
      return;
    }
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("batch_id", selectedBatch);
      formData.append("student_id", studentId);
      formData.append("status", 1); // always send status=1

      // Append image only if a file is selected
      if (selectedFiles[studentId]) {
        formData.append("image", selectedFiles[studentId]);
      }

      const response = await StudentListProfilePost(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);

        setSelectedFiles((prev) => ({ ...prev, [studentId]: null }));

        fetchStudents();
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar profile-update-screen">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid profile-update-container mt-2">
                <div className="row">
                  <IdCardLayout />
                  <div className="col-12">
                    <div className="card profile-update-filter-card p-4">
                      <div className="profile-update-header d-flex justify-content-between align-items-center mb-4">
                        {/* Left: Buttons */}
                        <div className="profile-update-tabs d-flex align-items-center">
                          <button
                            className={`btn btn-sm profile-update-tab ${
                              tab === "pending"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            } ms-1`}
                            onClick={() => setTab("pending")}
                          >
                            Not Uploaded
                          </button>

                          <button
                            className={`btn btn-sm profile-update-tab ${
                              tab === "uploaded"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            } ms-1`}
                            onClick={() => setTab("uploaded")}
                          >
                            Uploaded
                          </button>
                        </div>

                        {/* Right: Heading */}
                        <h3 className="profile-update-title text-primary fw-bold mb-0">
                          Student Profile{" "}
                          {tab.charAt(0).toUpperCase() + tab.slice(1)}
                        </h3>
                      </div>

                      <div className="row g-3 profile-update-filters">
                        <div className=" col-md-3 form-floating form-floating-outline">
                          <select
                            className="form-select"
                            name="session"
                            value={selectedSession}
                            onChange={(e) =>
                              setSelectedSessions(e.target.value)
                            }
                          >
                            {/* <option value="">Select Session</option> */}
                            {sessions?.map((session) => (
                              <option
                                key={session?.id}
                                value={session?.id}
                                selected={
                                  session?.status == "1" &&
                                  selectedSession?.status == "1" &&
                                  true
                                }
                              >
                                {session?.session}:
                                {session?.status == "1"
                                  ? "Active"
                                  : " Inactive"}
                                {/* Show "2023-24" */}
                              </option>
                            ))}
                          </select>

                          <label>Select Session</label>
                        </div>

                        <div className="col-md-3 form-floating form-floating-outline">
                          <select
                            className="form-select"
                            value={selectedBatch}
                            onChange={(e) => setSelectedBatch(e.target.value)}
                          >
                            <option value="">Select Batch</option>

                            {batch?.map((item) => {
                              const courseTitle = item?.course?.title || "";
                              const shortCourseTitle =
                                courseTitle.length > 20
                                  ? courseTitle.substring(0, 20) + "..."
                                  : courseTitle;

                              return (
                                <option key={item.id} value={item.id}>
                                  {item.title} ({shortCourseTitle})
                                </option>
                              );
                            })}
                          </select>

                          <label>Select Batch</label>
                        </div>
                      </div>
                    </div>
                    <div className="card profile-update-table-card mt-3">
                      <div className="card-body profile-update-table-body">
                        {tab == "pending" && (
                          <>
                            <div className="profile-update-section-heading">
                              <div>
                                <h4>Not Uploaded</h4>
                                <p>
                                  Capture and verify student profile photos.
                                </p>
                              </div>
                              <span className="profile-update-section-icon">
                                ↗
                              </span>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-hover align-middle profile-update-table">
                                <thead className="table-primary text-center">
                                  <tr>
                                    <th>Student Registration Number</th>
                                    <th>Name</th>
                                    {/* <th>Batch</th> */}
                                    <th>Photo</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Data?.data?.length > 0 ? (
                                    Data?.data?.map((student) => (
                                      <tr
                                        key={student.id}
                                        className="text-center"
                                      >
                                        <td>{student.registration_no}</td>
                                        <td>{student.name}</td>

                                        <td>
                                          {selectedFiles[student.id] ? (
                                            <img
                                              src={URL.createObjectURL(
                                                selectedFiles[student.id],
                                              )}
                                              alt="captured"
                                              style={{
                                                width: "54px",
                                                height: "54px",
                                                borderRadius: "12px",
                                                objectFit: "cover",
                                                border:
                                                  "2px solid var(--bs-border-color)",
                                                boxShadow:
                                                  "0 2px 8px rgba(0,0,0,.08)",
                                              }}
                                            />
                                          ) : student.profile_picture ? (
                                            <img
                                              src={`${
                                                imgBaseUrl +
                                                student.profile_picture
                                              }`}
                                              alt="student"
                                              style={{
                                                width: "54px",
                                                height: "54px",
                                                borderRadius: "12px",
                                                objectFit: "cover",
                                                border:
                                                  "2px solid var(--bs-border-color)",
                                                boxShadow:
                                                  "0 2px 8px rgba(0,0,0,.08)",
                                              }}
                                            />
                                          ) : (
                                            "No Photo"
                                          )}
                                        </td>
                                        <td>
                                          <input
                                            type="file"
                                            accept="image/*"
                                            capture="environment"
                                            style={{ display: "none" }}
                                            id={`capture-${student.id}`}
                                            onChange={(e) =>
                                              handleCapture(e, student.id)
                                            }
                                          />
                                          <button
                                            className="btn btn-sm btn-success profile-update-action me-1"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  `capture-${student.id}`,
                                                )
                                                .click()
                                            }
                                          >
                                            Capture
                                          </button>

                                          <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() =>
                                              updateProfile(student.id)
                                            }
                                            disabled={
                                              !selectedFiles[student.id]
                                            }
                                            title={
                                              !selectedFiles[student.id]
                                                ? "Capture a photo before verifying"
                                                : "Verify student profile"
                                            }
                                          >
                                            Verify
                                          </button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="5" className="text-center">
                                        No data found.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                              {/* Pagination */}
                              {Data?.links?.length > 0 && (
                                <nav
                                  aria-label="Page navigation"
                                  className="mt-3"
                                >
                                  <p>
                                    Showing {Data?.from || 0} to {Data?.to || 0}{" "}
                                    of {Data?.total || 0} entries
                                  </p>
                                  <ul className="pagination pagination-sm justify-content-center">
                                    {Data?.links?.map((btn, i) => (
                                      <li
                                        key={i}
                                        className={`page-item ${
                                          btn?.active ? "active" : ""
                                        } ${btn?.url ? "" : "disabled"}`}
                                      >
                                        <button
                                          className="page-link"
                                          onClick={() => {
                                            if (btn?.url) {
                                              if (i === 0)
                                                setPage(Data.current_page - 1);
                                              else if (
                                                i ===
                                                Data.links.length - 1
                                              )
                                                setPage(Data.current_page + 1);
                                              else setPage(parseInt(btn.label));
                                            }
                                          }}
                                        >
                                          {i === 0
                                            ? "«"
                                            : i === Data.links.length - 1
                                              ? "»"
                                              : btn.label}
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                </nav>
                              )}
                            </div>
                          </>
                        )}
                        {tab == "uploaded" && (
                          <>
                            <div className="profile-update-section-heading">
                              <div>
                                <h4>Uploaded Profiles</h4>
                                <p>
                                  Review uploaded photos and verification
                                  status.
                                </p>
                              </div>
                              <span className="profile-update-section-icon">
                                ✓
                              </span>
                            </div>
                            <div className="table-responsive">
                              <div className="table-responsive">
                                <table className="table table-hover align-middle profile-update-table">
                                  <thead className="table-primary text-center">
                                    <tr>
                                      <th>Student Registration Number</th>
                                      <th>Name</th>
                                      {/* <th>Batch</th> */}
                                      <th>Photo</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Data?.data?.length > 0 ? (
                                      Data?.data?.map((student) => (
                                        <tr
                                          key={student.id}
                                          className="text-center"
                                        >
                                          <td>{student.registration_no}</td>
                                          <td>{student.name}</td>

                                          <td>
                                            {selectedFiles[student.id] ? (
                                              <img
                                                src={URL.createObjectURL(
                                                  selectedFiles[student.id],
                                                )}
                                                alt="captured"
                                                style={{
                                                  width: "54px",
                                                  height: "54px",
                                                  borderRadius: "12px",
                                                  objectFit: "cover",
                                                  border:
                                                    "2px solid var(--bs-border-color)",
                                                  boxShadow:
                                                    "0 2px 8px rgba(0,0,0,.08)",
                                                }}
                                              />
                                            ) : student.profile_picture ? (
                                              <img
                                                src={`${
                                                  imgBaseUrl +
                                                  student.profile_picture
                                                }`}
                                                alt="student"
                                                style={{
                                                  width: "54px",
                                                  height: "54px",
                                                  borderRadius: "12px",
                                                  objectFit: "cover",
                                                  border:
                                                    "2px solid var(--bs-border-color)",
                                                  boxShadow:
                                                    "0 2px 8px rgba(0,0,0,.08)",
                                                }}
                                              />
                                            ) : (
                                              "No Photo"
                                            )}
                                          </td>
                                          {/* <td>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          capture="environment"
                                          style={{ display: "none" }}
                                          id={`capture-${student.id}`}
                                          onChange={(e) => handleCapture(e, student.id)}
                                        />
                                        <button
                                          className="btn btn-sm btn-success profile-update-action me-1"
                                          onClick={() =>
                                            document.getElementById(`capture-${student.id}`).click()
                                          }
                                        >
                                          Capture
                                        </button>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={() => handleVerify(student.id)}
                                        >
                                          Verify
                                        </button>
                                      </td> */}
                                          <td>
                                            <span className="badge bg-success profile-update-status">
                                              Verified
                                            </span>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="5" className="text-center">
                                          No data found.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>

                                {/* Pagination */}
                                {Data?.links?.length > 0 && (
                                  <nav
                                    aria-label="Page navigation"
                                    className="mt-3"
                                  >
                                    <p>
                                      Showing {Data?.from || 0} to{" "}
                                      {Data?.to || 0} of {Data?.total || 0}{" "}
                                      entries
                                    </p>
                                    <ul className="pagination pagination-sm justify-content-center">
                                      {Data?.links?.map((btn, i) => (
                                        <li
                                          key={i}
                                          className={`page-item ${
                                            btn?.active ? "active" : ""
                                          } ${btn?.url ? "" : "disabled"}`}
                                        >
                                          <button
                                            className="page-link"
                                            onClick={() => {
                                              if (btn?.url) {
                                                if (i === 0)
                                                  setPage(
                                                    Data.current_page - 1,
                                                  );
                                                else if (
                                                  i ===
                                                  Data.links.length - 1
                                                )
                                                  setPage(
                                                    Data.current_page + 1,
                                                  );
                                                else
                                                  setPage(parseInt(btn.label));
                                              }
                                            }}
                                          >
                                            {i === 0
                                              ? "«"
                                              : i === Data.links.length - 1
                                                ? "»"
                                                : btn.label}
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  </nav>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
